import PaintProcurementQuotationsWorkspace from '../../placeholders/PaintProcurementQuotationsWorkspace';

export default PaintProcurementQuotationsWorkspace;
